import { Modal } from 'antd'
import Styles from '../css/vehicleModals.module.scss'
import  Cancel from "../../../../assets/cancel.svg";
import  Caution from "../../../../assets/cautionfailedicon.svg";

const VehicleLoanCancellVerificationModal = (props:any) => {
    return ( 
        <div>
            <Modal title="Basic Modal" centered destroyOnClose={true} width={400} open={props.isModalOpen} onOk={props.handleOk} onCancel={props.handleCancel}>
                <div className={Styles.modalContentVerification}>
                   <div className={Styles.cancelDiv}><img onClick={props.handleCancel} src={Cancel} className={Styles.cancelIcon} alt="horse" /></div>
                   <div className={Styles.cautionDiv}><img src={Caution} className={Styles.cautionIcon} alt="horse" /></div>
                   <div style={{textAlign:'center'}} className={Styles.title}>Are you sure you want to cancel ?</div>
                   {/* <div style={{textAlign:'center'}} className={Styles.descTwo}>Cancelling the loan will terminate the booked loan, please ensure your account is adequately funded for the loan reversal</div> */}
                   <button onClick={props.openCancelReason} className={Styles.btn}>YES</button>
                   <button onClick={props.handleCancel} className={Styles.btnOutline}>NO</button>
                </div>
            </Modal>   
        </div>
    );
}
 
export default VehicleLoanCancellVerificationModal;